import {
  AnnotationListState,
  initialAnnotationListState,
} from '../../utils/annotation-list.state.abstract';

export type HighlightListState = AnnotationListState;

export const initialHighlightListState: HighlightListState = {
  ...initialAnnotationListState,
};
